import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import "../BusinessPOC/UploadNomination.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import "./SMENominationList.css";
import Axios from "axios";
import Alert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { updateCount } from "../Redux/THSlice";
import {
 getNominationListBasedOnSkills,
 smeAction,
 getFilterNominationList,
 fetchUserListByCourse,
 fetchWaitingForApprovalList,
 updateCountSME
} from "../Redux/SmeSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import usePagination from "./CustomPagination";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PrimarySkillsFilter from './SMENominationList/PrimarySkillsFilter';

const style = {
  position: "absolute",
  top: "38%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  padding: '20px',
  borderRadius:'5px'
};

const SMENominationList = ({ courseCodeNm, date, selectedCourseName }) => {
 const dispatch = useDispatch();
 const trainingSkillList = useSelector((state) => state.sme.trainingSkills);
 const [tickIconActive, setTickIconActive] = useState(false);
 const [crossIconActive, setCrossIconActive] = useState(false);
 const [trainingSkills, setTrainingSkills] = useState([]);
 const [trainingList, setTrainingList] = useState([]);
 const courseList = useSelector((state) => state?.sme?.courseWiseList) ?? false;
 const [rejectOpenModal, setRejectOpenModal] = useState(false);
 const [alert, setAlert] = useState(false);
 const [alertText, setAlertText] = useState("");
 const [reason, setReason] = useState("");
 const [isNull, setIsNull] = useState(false);
 const [rejectedId, setRejectedId] = useState([]);
 const [filter, setFilter] = useState(0);
 let nominatedCount = useSelector((state) => state.sme.nominatedCountSME);
 let rejectedCount = useSelector((state) => state.sme.rejectedCountSME);
 let approvedCount = useSelector((state) => state.sme.approvedCountSME);
 const [selectAllChecked, setSelectAllChecked] = useState(false);
 const [rejectAllChecked, setRejectAllChecked] = useState(false);
 const [selectedItems, setSelectedItems] = useState({});
 const [rejectedItems, setRejectedItems] = useState({});
 const [approveOpenModal, setApproveOpenModal] = useState(false);
 const [rejectAllOpenModal, setRejectAllOpenModal] = useState(false);
 const [rejectYesOpenModal, setRejectYesOpenModal] = useState(false);
 const [rejectAllRefresh, setRejectAllRefresh] = useState(false);
 const [rejectionReason, setRejectionReason] = useState("Skill Mismatch");
 const {isLoader, isDataSentSuccess, isDataSentFailure} = useSelector((state) => state.sme);
 const statusMessage = {1: "Waiting for approval", 2: "Waiting for Batch Allocation" , 3: "Rejected", 
  4: "Scheduled", 5: "Cancelled"}
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  //const [page, setPage] = useState(1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const [approvalStatusCount, setApprovalStatusCount] = useState(0);
  
  //  const PER_PAGE = 5;
  //  const startIndex = (page - 1) * PER_PAGE;
  //  const endIndex = startIndex + PER_PAGE;
  
  const [checkAll, setCheckAll] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [filteredData, setFilteredData] = useState([]); 
  const [dataForApprovals, setDataForApprovals] = useState([]);

  useEffect(()=> {
    if(courseList != undefined && filteredData?.length != 0){
    const approvals = filteredData.filter(item => item.status == 1);
    setDataForApprovals(approvals);
    }
  }, [courseList, filteredData, alert]) 
  console.log('dataForApprovals', dataForApprovals,)

  useEffect(() => {
    const allChecked = dataForApprovals.every(item => checkedItems[item.enterpriseID]);
    setCheckAll(allChecked);
  }, [courseList, checkedItems, dataForApprovals]);

  const handleCheckboxChange = (event, enterpriseID) => {
    setCheckedItems(prev => {
      const updatedCheckedItems = { ...prev, [enterpriseID]: event.target.checked };
      const allChecked = dataForApprovals.every(item => updatedCheckedItems[item.enterpriseID]);
      console.log('allChecked', allChecked)
      setCheckAll(allChecked);
      return updatedCheckedItems;
    });
  };

  useEffect(() =>{
    const updatedCheckedItems = {};
    dataForApprovals.forEach(item => {
      if (filter === 0) {
        updatedCheckedItems[item.enterpriseID] = true;
      } else {
        updatedCheckedItems[item.enterpriseID] = false;
      }
    });
    setCheckedItems(updatedCheckedItems);
  }, [filter])

  useEffect(() => {    
    if(courseList != undefined){
    let filteredCourseData = courseList.filter(item => (item.primarySkills !== null))
    if(filter === 0){
     setFilteredData(filteredCourseData);
    }else{
    let filteredStatusData = filteredCourseData.filter((item) => (item.status == filter))
    setFilteredData(filteredStatusData);
    }}
  },[courseList, filter])

function getApprovalStatusCount() {
  let approvalStatusCount = (rowsPerPage > 0 ? 
  filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : 
  filteredData).filter((item) => {return item.status == 1})  
  setApprovalStatusCount(approvalStatusCount.length);
}
const handleCheckAll = (event) => {
  const isChecked = event.target.checked;
  setCheckAll(isChecked);
  const updatedCheckedItems = {};
  dataForApprovals.forEach(item => {
    if (filter === 0) {
      updatedCheckedItems[item.enterpriseID] = isChecked;
    }
  });
  setCheckedItems(updatedCheckedItems);
};
let checkedItemsArray = Object.entries(checkedItems)
  .filter(([key, value]) => value === true)

const handleSelectAll = () => { 
  const checkedItemsArray = Object.entries(checkedItems)
  .filter(([key, value]) => value === true)
  .map(([key, value]) => key); 

  checkedItemsArray.forEach((item) => {    
    handleSubmit(item, 2, "Approved", "Success", 1);
  });
  setCheckedItems({});
  setRejectAllRefresh(!rejectAllRefresh);
  handleApproveModalClose();            
  getApprovalStatusCount();
};

const handleRejectAll = () => {     
  const checkedItemsArray = Object.entries(checkedItems)
  .filter(([key, value]) => value === true)
  .map(([key, value]) => key); 

  checkedItemsArray.forEach((item) => {          
      handleSubmitRejection(item, 3, rejectionReason === "Others" ? reason : rejectionReason,1);        
    });    
    setRejectAllRefresh(!rejectAllRefresh);
    handleApproveModalClose();  
    setCheckedItems({})
    getApprovalStatusCount();
}

 const handleApproveModalOpen = () => {
  setApproveOpenModal(true);
  setSelectAllChecked(true);
 }
 const handleApproveModalClose = () => {
  setApproveOpenModal(false);
  setSelectAllChecked(false);
 };

 const handleRejectAllModalOpen = () => {
  setRejectAllOpenModal(true);
  setRejectAllChecked(true);
 }
 const handleRejectAllModalClose = () => {
  setRejectAllOpenModal(false);
  setRejectAllChecked(false);
 };

 const handleRejectYesModalOpen = () => setRejectYesOpenModal(true);
 const handleRejectYesModalClose = () => {
  setRejectYesOpenModal(false);
 };

 useEffect(() => {
 dispatch(getFilterNominationList(courseCodeNm, date));
 }, [rejectAllRefresh]);

 const handleStatusFilter = (event) => {
  setFilter(event.target.value);
 };

 function handleRejectionReason(event) {
    console.log(event.target.value);
    setRejectionReason(event.target.value);
 }

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };

 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };
 const handleApproveStatusClick = (index) => {
  setTickIconActive(index);
  setCrossIconActive(false);
 };

 const handleRejectStatusClick = (index) => {
  setCrossIconActive(index);
  setTickIconActive(false);
  handleRejectModalOpen();
 };
 const handleRejectModalOpen = () => setRejectOpenModal(true);
 const handleRejectModalClose = () => {
  setRejectOpenModal(false);
  setCrossIconActive(false);
 };

 const handleSubmit = (id, status, alertValue, reason, count) => {
  setAlert(true);
  dispatch(smeAction(id, status, reason, courseCodeNm, date));
  setAlertText(alertValue);
  dispatch(updateCountSME(status, count));
 };

 const handleSubmitRejection = (idsToReject, status, reason, count) => {
  if (reason == "") {
   setIsNull(true);
  }
  if (reason != "") {
   dispatch(smeAction(idsToReject, 3, reason, courseCodeNm, date));
   dispatch(updateCountSME(3,count));
   setAlert(true);
   setAlertText("Rejected");
   setRejectOpenModal(false);
   setReason("");
   setIsNull(false);
   dispatch(updateCount(3));
   handleRejectYesModalClose();
   handleRejectAllModalClose();
  }
 };


 return (
  <>
   <ThemeProvider theme={theme}>
    <Box className="SME_nomination_list_main">
     {alert && (
      <Alert
       color="info"
       severity="success"
       onClose={() => setAlert(false)}
       sx={{ position: "fixed", top: "0px", right: "0px", width: "300px", zIndex:"1000" }}
      >
       {alertText}
      </Alert>
     )}
     {/* <Typography variant="h3" component="p" className="SME_session_header">
      Status of Candidate's nomination for {selectedCourseName}.
     </Typography> */}     
     <Stack
      direction={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      marginTop={"10px"}        
     >
      {/* <Stack direction={"row"} justifyContent={"space-between"}>
       <Typography sx={{ fontSize: "14px", color: "#696969",fontWeight: '900' }}>
        Number of Nominations :
        <span style={{ fontSize: "16px", fontWeight: "600", color: "blue" }}>
         {nominatedCount}
        </span>
       </Typography>
       <Typography sx={{ fontSize: "14px", color: "#696969", marginLeft: "15px",fontWeight: '900' }}>
        Number of Approved Nominations :
        <span style={{ fontSize: "16px", fontWeight: "600", color: "blue" }}>
         {approvedCount}
        </span>
       </Typography>
       <Typography sx={{ fontSize: "14px", color: "#696969", marginLeft: "15px",fontWeight: '900' }}>
        Number of Rejected Nominations :
        <span style={{ fontSize: "16px", fontWeight: "600", color: "blue" }}>
         {rejectedCount}
        </span>
       </Typography>
      </Stack> */}        
        <h3 style={{fontWeight: '900',textDecoration: 'underline',fontSize: '18px',marginBottom: '22px'}}>Nominations for {selectedCourseName}</h3>        
     </Stack>
      {/* <Stack
      direction={"row"}
      justifyContent={"space-between"}> */}
     {/* <Box
      sx={{
       width: 500,
       maxWidth: "100%",
       paddingBottom: "10px",
      }}
     >
      <TextField
       fullWidth
       label="Search skills..."
       id="fullWidth"
       value={searchQuery}
       sx={{
        "& label.Mui-focused": {
         color: "#7500c0",
        },
        "& .MuiOutlinedInput-root": {
         "&.Mui-focused fieldset": {
          borderColor: "#7500c0",
         },
         "&:hover fieldset": {
          borderColor: "#7500c0",
         },
         "&.Mui-focused fieldset": {
          borderColor: "#7500c0",
         },
         "& fieldset": {
          borderColor: "#7500c0",
          border: "2px solid #7500c0",
         },
        },
       }}
       onChange={handleSearchSkills}
       InputProps={{
        endAdornment: (
         <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
          <SearchIcon />
         </IconButton>
        ),
       }}
      />
     </Box> */}

      {/* <Typography className="upload_section_para">
        This section allows you to review the candidate skills and approve / reject the
        nomination based on the skills pre-requisites for attending the training.
      </Typography> */}
     {!isLoader && filteredData.length != 0 && filteredData != undefined ?
     <>
     <FormGroup className="checkbox_section">
      {/* <FormControlLabel control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28, color: "#7500c0" } }} checked={selectAllChecked} 
      //onChange={(event) => handleSelectAll(event)}
      onClick={handleApproveModalOpen}
      />} 
      label="Approve All" sx={{marginRight: "0px !important"}}/> */}
      
      <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',margin: '10px 0'}}>
        {/* <div>
          {(checkAll || selectedCheckboxes.length > 0) && <button onClick={handleApproveModalOpen} style={{cursor: 'pointer',border: 'none', backgroundColor: 'blueViolet',padding: '5px 10px', marginRight:'5px',borderRadius: '4px', color: 'white'}}>Approve</button>}
          {(checkAll || selectedCheckboxes.length > 0) && <button onClick={handleRejectAllModalOpen} style={{cursor: 'pointer',border: 'none', backgroundColor: 'blueViolet',padding: '5px 10px', borderRadius: '4px', color: 'white'}}>Reject</button>}
        </div>
        <div>
          <span style={{fontWeight: '900'}}>Nominations for {selectedCourseName}</span>
        </div> */}
        <Stack direction={"column"} alignItems={"baseline"}>
          <Typography sx={{ fontSize: "16px", color: "black",fontWeight: '900' }}>
            Total number of Nominations:  
            <span style={{ fontSize: "16px", fontWeight: "600", color: "blue", verticalAlign: 'middle', 'margin-left':'3px' }}>
            {nominatedCount}
            </span>
          </Typography>
          <Typography sx={{ fontSize: "15px", color: "black", marginLeft: "15px",fontWeight: '900' }}>
            Number of Approved Nominations:
            <span style={{ fontSize: "16px", fontWeight: "600", color: "blue", verticalAlign: 'middle','margin-left':'3px' }}>
            {approvedCount}
            </span>
          </Typography>
          <Typography sx={{ fontSize: "15px", color: "black", marginLeft: "15px",fontWeight: '900' }}>
            Number of Rejected Nominations:
            <span style={{ fontSize: "16px", fontWeight: "600", color: "blue", verticalAlign: 'middle','margin-left':'3px' }}>
            {rejectedCount}
            </span>
          </Typography>
        </Stack>
        <div style={{display: 'flex',flexDirection: 'row',alignItems: 'center'}}> 
            {checkedItemsArray.length > 0 && 
          <div style={{display: 'flex','margin-right': '25px'}}>
            {<button onClick={handleApproveModalOpen} style={{cursor: 'pointer',border: 'none', backgroundColor: 'blueViolet',padding: '8px 12px', marginRight:'5px',borderRadius: '4px', color: 'white','font-weight': '900','font-size': '15px'}}>Approve</button>}
            {<button onClick={handleRejectAllModalOpen} style={{cursor: 'pointer',border: 'none', backgroundColor: 'blueViolet',padding: '8px 22px', borderRadius: '4px', color: 'white','font-weight': '900','font-size': '15px'}}>Reject</button>}
          </div>  
            }
          {(checkedItemsArray.length > 0) && <div style={{'border-left': '4px solid grey',height: '50px'}}></div>}
          <TablePagination className="sme_pagination" rowsPerPageOptions={[25, 50, 100]} component="div" count={filteredData.length}
            rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{".MuiTablePagination-spacer": {display: "none",},}}/>
        </div>
      </div>                  
      <Modal open={approveOpenModal} onClose={handleApproveModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="reject_modal">
        <Box sx={style}>
          {/* <span className="upload_close_btn_model" onClick={handleApproveModalClose}>
            X
          </span> */}
          <Typography
          sx={{ fontWeight: "600", fontSize: "16px",textAlign: 'center', marginBottom: "20px" }}
          >
          Are you sure you want to approve selected nominations?
          </Typography>
          <div style={{textAlign: 'center'}}>          
            <button className="approve_yes_button" onClick={(event) => handleSelectAll(event)}>
              Yes
            </button>
            <button className="approve_no_button" onClick={handleApproveModalClose}>
              No
            </button>
          </div>
        </Box>
      </Modal>

      </FormGroup>
      <FormGroup className="checkbox_section1">
      {/* <FormControlLabel control={<Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 28, color: "#7500c0" } }} checked={rejectAllChecked} 
      //onChange={(event) => handleSelectAll(event)}
      onClick={handleRejectAllModalOpen}
      />} 
      label="Reject All" sx={{marginRight: "0px !important"}}/> */}      
       <Modal
              open={rejectAllOpenModal}
              onClose={handleRejectAllModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="reject_modal"
             >
              <Box sx={style}>
               {/* <span className="upload_close_btn_model" onClick={handleRejectAllModalClose}>
                X
               </span> */}
               <Typography
                sx={{ fontWeight: "600", fontSize: "16px",textAlign: 'center', marginBottom: "20px" }}
               >
                Are you sure you want to reject selected nominations?
               </Typography>
                <div style={{textAlign: 'center'}}>                
                  <button className="approve_yes_button" variant="contained" onClick={handleRejectYesModalOpen}>
                    Yes
                  </button>             
                  <button className="approve_no_button" variant="contained" onClick={handleRejectAllModalClose}>
                    No
                  </button>
                </div>
                <Modal
              open={rejectYesOpenModal}
              onClose={handleRejectYesModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="reject_modal"
             >
              <Box sx={style}>
               <span className="upload_close_btn_model" onClick={handleRejectYesModalClose}>
                X
               </span>
               <Typography
                sx={{ fontWeight: "600", fontSize: "16px", marginBottom: "20px" }}
               >
                Reason for Rejection
               </Typography>               
               <FormControl fullWidth id="rejection-reasons">
                {/* <InputLabel id="demo-simple-select-label">Reason</InputLabel> */}
                <Select
                labelId="demo-simple-select-label"
                id="rejection-reasons"
                value={rejectionReason}
                label="Status"
                onChange={handleRejectionReason}
                displayEmpty
                >                         
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value="Skill Mismatch">
                  Skill Mismatch
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value="Slots full">
                  Slots full
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value="Others">
                  Others
                </MenuItem>                
                </Select>
              </FormControl>
              {rejectionReason === "Others" && <div id="rejection-reason-input-box"><TextField
                error={isNull ? true : false}
                required={!isNull ? false : true}
                placeholder="Enter reason"
                fullWidth
                multiline
                id={isNull ? "outlined-error" : "outlined-required"}                                
                helperText={isNull ? "Please enter the reason" : null}
                sx={{ width: "100%", fontSize: "14px !important" }}
                onChange={(e) => {setReason(e.target.value)}}
                value={reason}
               /></div>}
                <div style={{textAlign: 'center'}}>
                  <button className="reject_modal_button" onClick={handleRejectAll}>
                    Submit
                  </button>
                </div>
              </Box>
                </Modal>
              </Box>
             </Modal>
      </FormGroup>
      </>
       : 
      "" }
     {/* </Stack>  */}
     
     {!isLoader ? <Box className="nomination_fetch_table">
        <TableContainer component={Paper}>
         <Table size="large" aria-label="a dense table">
          <TableHead>
           <TableRow>            
            <TableCell>Sl No</TableCell>            
            <TableCell>Enterprise ID</TableCell>            
            <TableCell>
              Primary Skill
              <PrimarySkillsFilter filteredData={filteredData} setFilteredData={setFilteredData} courseList={courseList} skillType='primary'/>              
            </TableCell>
            <TableCell>
              Secondary Skill
              <PrimarySkillsFilter filteredData={filteredData} setFilteredData={setFilteredData} courseList={courseList} skillType='secondary'/>  
            </TableCell>
            <TableCell>
              Requester ID
              <PrimarySkillsFilter filteredData={filteredData} setFilteredData={setFilteredData} courseList={courseList} skillType='requester_id'/>
            </TableCell>
            <TableCell sx={{ background: "#4d0a77" }}>                                
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter}
                label="Status"
                onChange={handleStatusFilter}
                displayEmpty
                >         
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={0}>
                  All
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={1}>
                  Waiting for Approval
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={2}>
                  Waiting for Batch Allocation
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={3}>
                  Rejected
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={4}>
                  Scheduled
                </MenuItem>
                <MenuItem sx={{ color: "#7500C0", fontSize: "14px" }} value={5}>
                  Cancelled
                </MenuItem>
                </Select>
              </FormControl>                              
            </TableCell>
            <TableCell>
            {filteredData.length != 0 && filteredData != undefined && dataForApprovals?.length > 0 &&
            <Checkbox
                indeterminate={Object.values(checkedItems).some(value => value) && !checkAll}
                checked={checkAll}
                onChange={handleCheckAll}
                sx={{color: "#fff"}}
              />  
            }                      
              {/* {(approvalStatusCount > 0) && <input type="checkbox" checked={checkAll} onChange={() => handleAllCheckUncheck()}/>} */}
            </TableCell>
           </TableRow>
          </TableHead>
          {filteredData.length != 0 && filteredData != undefined ? <TableBody>            
           {(rowsPerPage > 0
            ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : filteredData
           ).map((item, index) => {
            const {enterpriseID, primarySkills,secondarySkills, nominatedBy, status, reason } = item;
            return(
            <TableRow key={index} scope="row">                            
             <TableCell scope="row">{page * rowsPerPage + index + 1}.</TableCell>              
             <TableCell>{enterpriseID}</TableCell>             
             {/* <TableCell>{item.courseCode}</TableCell>
             <TableCell>{item.sessionCode}</TableCell> */}
             {/* <TableCell>{item.courseName}</TableCell> */}
             <TableCell>{primarySkills}</TableCell>
             <TableCell>{secondarySkills === null ? 'null' : secondarySkills}</TableCell>
             <TableCell>{nominatedBy}</TableCell>
             <TableCell className="fix">
              {statusMessage[status] == "Rejected" ? 
               <div style={{display: 'flex', flexDirection: 'column'}}>
               <Typography className="reject-typo">Rejected</Typography>
               <div style={{fontSize: '12px'}}>
                 <span style={{color:'red'}}>Reason: </span>
                 <span className="reason_span">{reason}</span>
               </div>
             </div> :
             statusMessage[status]
              }
             </TableCell>
             <TableCell> 
              {
                status == 1 &&
                <Checkbox
                  checked={checkedItems[enterpriseID] || false}
                  onChange={(event) => handleCheckboxChange(event, enterpriseID)}
                /> 
              }
               
              </TableCell>
             <Modal
              open={rejectOpenModal}
              onClose={handleRejectModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="reject_modal"
             >
              <Box sx={style}>
               <span className="upload_close_btn_model" onClick={handleRejectModalClose}>
                X
               </span>
               <Typography
                sx={{ fontWeight: "600", fontSize: "16px", marginBottom: "20px" }}
               >
                Reason for Rejection
               </Typography>
               <TextField
                error={isNull ? true : false}
                required={!isNull ? false : true}
                fullWidth
                multiline
                id={isNull ? "outlined-error" : "outlined-required"}
                variant="outlined"
                //   label={isNull ? "" : "Ex - Azure Certification"}
                helperText={isNull ? "Please enter the reason" : null}
                sx={{ width: "100%", fontSize: "14px !important" }}
                onChange={(e) => {
                 //    if (e.target.value !== "") {
                 // setIsNull(true);
                 setReason(e.target.value);
                 //    }
                }}
                value={reason}
               />
               <Button
                // type="submit"
                className="reject_modal_button"
                variant="contained"
                onClick={()=>{handleSubmitRejection(rejectedId,3,reason,1)}}
               >
                Submit
               </Button>
              </Box>
             </Modal>
            </TableRow>
           )})}
          </TableBody> : <TableBody><TableRow scope="row">
              <TableCell colSpan={5}>No Nominations Found</TableCell>              
            </TableRow></TableBody>}
         </Table>
        </TableContainer>

        {/* <Stack className="pagination_stack">
        <Pagination count={count} 
        page={page} onChange={handleChange} color="secondary" />
       </Stack> */}
        <TablePagination
         className="sme_pagination"
         rowsPerPageOptions={[25, 50, 100]}
         component="div"
         count={filteredData.length}
         rowsPerPage={rowsPerPage}
         page={page}
         onPageChange={handleChangePage}
         onRowsPerPageChange={handleChangeRowsPerPage}
         sx={{
          ".MuiTablePagination-spacer": {
           display: "none",
          },
         }}
        />
      </Box> : 
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
     }
    </Box>
   </ThemeProvider>
  </>
 );
};

export default SMENominationList;
